<template>
  <user-photo :user="user" />
</template>
<script>

import UserPhoto from '@/components/shared/UserPhoto'
import { mapState } from 'vuex'

export default {
  components: { UserPhoto },
  computed: mapState({
    user: state => state.user.user
  })
}
</script>
